import clsx from 'clsx'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { EnumGlobalRoutes } from '../../app/router/routerConstants'
import { setActiveRole } from '../../features/auth/authSlice'
import { useGetMeQuery } from '../../services/auth'
import type { RootState } from '../../store'
import { UserRoleEnum, ROLE_LABELS } from '../../types'
import Modal from '../common/Modal'
import { baseApi } from '@/services/baseApi'

interface SelectActiveRoleModalProps {
    isOpen: boolean
    onClose: () => void
}

export const ALLOWED_ROLES: UserRoleEnum[] = [
    UserRoleEnum.DISPATCHER,
    UserRoleEnum.TENANT_ADMIN,
    UserRoleEnum.EXECUTIVES,
]

const SelectActiveRoleModal = ({
    isOpen,
    onClose,
}: SelectActiveRoleModalProps) => {
    const { activeRole, user } = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { data } = useGetMeQuery()

    const roles: UserRoleEnum[] = Array.isArray(user?.roles)
        ? (user.roles as UserRoleEnum[])
        : (data?.data?.roles as UserRoleEnum[]) || []

    const filteredRoles = roles.filter((role) => ALLOWED_ROLES.includes(role))

    const handleSelectRole = (role: UserRoleEnum) => {
        dispatch(setActiveRole(role))
        navigate(EnumGlobalRoutes.DASHBOARD)
        dispatch(baseApi.util.resetApiState())
        setTimeout(() => onClose(), 500)
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Select Your Role">
            <div className="modal__body p-0">
                <div className="tabs-links-list modal__tabs__body items-center justify-center">
                    {filteredRoles.map((role, index) => (
                        <button
                            key={index}
                            onClick={() => handleSelectRole(role)}
                            className={clsx(
                                'btn full-radius btn--md btn-tab-custom',
                                { 'active-tab': activeRole === role },
                            )}
                        >
                            <span>{ROLE_LABELS[role] || role}</span>
                        </button>
                    ))}
                </div>
            </div>
        </Modal>
    )
}

export default SelectActiveRoleModal
